import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { switchToLevel } from "../ai-first/helpers";
import { text } from "@quickpoint.me/shared";

const summary: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11ySummaryHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11ySummaryPrefix} <strong>{text.tourSteps.a11ySummaryStandard}</strong> {text.tourSteps.a11ySummarySuffix}
						<br />
						<br />
						- {text.tourSteps.a11ySummaryTextBased}
						<br />
						- {text.tourSteps.a11ySummaryKeyboard}
						<br />
						- {text.tourSteps.a11ySummaryLandmarks}
						<br />
						- {text.tourSteps.a11ySummarySkipLink}
						<br />
						- {text.tourSteps.a11ySummaryFocus}
						<br />
						- {text.tourSteps.a11ySummaryLiveRegions}
						<br />
						- {text.tourSteps.a11ySummaryAltText}
						<br />
						- {text.tourSteps.a11ySummaryMotionContrast}
							<br />
							- {text.tourSteps.a11ySummaryContrast}
							<br />
							- {text.tourSteps.a11ySummaryTargets}
						<br />
						- {text.tourSteps.a11ySummaryViewerSettings}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: ".tour",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.a11yRevisit}
			/>
		),
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yEnd}
						<br />
						<br />
						{text.tourSteps.a11yStartCreating}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			switchToLevel(1);
		},
	},
];

export default summary;
